import React, { useState } from 'react';
import { Select, Input, Button as AntButton, Space } from 'antd';
import { Card, SectionTitle } from './SharedComponents'; // Import from the new shared file

const { Option } = Select;

const UiBrief: React.FC = () => {
  const [selectValue, setSelectValue] = useState<string | undefined>(undefined);
  const [inputValue, setInputValue] = useState<string>('');

  return (
    <div className="min-h-screen bg-gray-50 py-6">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">UI Bileşenleri Gösterimi</h1>

        {/* Select Bileşeni */}
        <Card>
          <SectionTitle>Select (Ant Design)</SectionTitle>
          <div className="pt-4 space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Basit Select
              </label>
              <Select
                placeholder="Bir seçenek seçin"
                value={selectValue}
                onChange={(value) => setSelectValue(value)}
                style={{ width: 200 }}
                allowClear
              >
                <Option value="option1">Seçenek 1</Option>
                <Option value="option2">Seçenek 2</Option>
                <Option value="option3">Seçenek 3</Option>
                <Option value="disabled" disabled>
                  Devre Dışı Seçenek
                </Option>
              </Select>
              <p className="text-xs text-gray-500 mt-1">Seçilen Değer: {selectValue || 'Yok'}</p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Grup Seçenekleri ile Select
              </label>
              <Select defaultValue="lucy" style={{ width: 200 }}>
                <Select.OptGroup label="Yönetici">
                  <Option value="jack">Jack</Option>
                  <Option value="lucy">Lucy</Option>
                </Select.OptGroup>
                <Select.OptGroup label="Mühendis">
                  <Option value="yiminghe">Yiminghe</Option>
                </Select.OptGroup>
              </Select>
            </div>
          </div>
        </Card>

        {/* Input Bileşeni */}
        <Card>
          <SectionTitle>Input (Ant Design)</SectionTitle>
          <div className="pt-4 space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Basit Input
              </label>
              <Input
                placeholder="Bir şeyler yazın..."
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
              />
              <p className="text-xs text-gray-500 mt-1">Girilen Değer: {inputValue || 'Yok'}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                TextArea
              </label>
              <Input.TextArea rows={3} placeholder="Uzun metin girin..." />
            </div>
          </div>
        </Card>

        {/* Button Bileşeni */}
        <Card>
          <SectionTitle>Button (Ant Design)</SectionTitle>
          <div className="pt-4">
            <Space wrap>
              <AntButton type="primary">Primary Button</AntButton>
              <AntButton>Default Button</AntButton>
              <AntButton type="dashed">Dashed Button</AntButton>
              <AntButton type="text">Text Button</AntButton>
              <AntButton type="link">Link Button</AntButton>
              <AntButton type="primary" danger>Primary Danger</AntButton>
              <AntButton danger>Default Danger</AntButton>
              <AntButton type="dashed" danger>Dashed Danger</AntButton>
              <AntButton type="text" danger>Text Danger</AntButton>
              <AntButton type="link" danger>Link Danger</AntButton>
            </Space>
          </div>
        </Card>

      </div>
    </div>
  );
};

export default UiBrief;
